var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrlBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.071,
    height: 19.054,
    viewBox: "0 0 19.071 19.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M10,11.385a4.266,4.266,0,0,0,6.432.461l2.559-2.559A4.265,4.265,0,1,0,12.96,3.254L11.493,4.714",
    transform: "translate(-3.171 -2.005)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M12.237,10.705A4.266,4.266,0,0,0,5.8,10.245L3.245,12.8a4.265,4.265,0,1,0,6.032,6.032l1.458-1.459",
    transform: "translate(-1.995 -3.031)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlBlackIcon);
export default __webpack_public_path__ + "static/media/url-black-icon.9b35eb307fc215d56101ead117408b5d.svg";
export { ForwardRef as ReactComponent };